import { ECommuteDistanceType } from '../../../../types/filters';
import { generateDistanceLabel } from '../../../../utils/generateDistanceLabel';

export const generateDistanceTypes = (regionId: number | undefined) => {
  return [
    { value: ECommuteDistanceType.Road, label: generateDistanceLabel(ECommuteDistanceType.Road, regionId) },
    { value: ECommuteDistanceType.Station, label: generateDistanceLabel(ECommuteDistanceType.Station) },
  ];
};
